import React from 'react';

const Subtitle = ({className, ...props}) => {
    return (
        <h1 className={`${className} text-xl font-bold text-green-900`} {...props}>
            {props.children}
        </h1>
    );
};

export default Subtitle;